import AttendHelpLayoutList from './AttendHelpLayoutList';

export default AttendHelpLayoutList;
